import React, { useEffect, useState } from "react";
import NavBar from "../../../Components/Navbar/navbar";
import styles from "../../Styles/edit.module.css";
import axios from "axios";
import RefreshToken from "../../../Components/RefreshToken/RefreshToken";
import { useParams, useNavigate, useLocation } from "react-router";
import Alert from "../../../Components/Alert/alert";
import Dropdown from "../../../Components/Dropdown/dropdown";
import { Url, getUser } from "../../../Constants/globals";
import MultiSelect from "../../../Components/MultiSelect/multiselect";
import { HiCheck, HiPencil, HiPlusCircle, HiTrash, HiXCircle, HiInformationCircle } from "react-icons/hi";
import TextareaAutosize from 'react-autosize-textarea';
import DeleteModal from "../../../Components/DeleteModal/deletemodal";
import GoBack from "../../../Components/GoBack/goback";

async function getCategories(page){
  try {
    const res = await axios
    .get(`${Url}/protocol-types?page=${page ? page : 1}&order_by=name`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getCategories(page);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getProfiles(){
  try {
    const res = await axios
    .get(`${Url}/profiles`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getProfiles();
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getCompanies(){
  try {
    const res = await axios
    .get(`${Url}/companies?order_by=name`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getCompanies();
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getProtocolDetails(id){
  try {
    const res = await axios
    .get(Url + "/protocols/"+id, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await getProtocolDetails(id);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function handleAddService(nome, protocolId, setAddService){
  if (nome === ""){
    return <Alert type={"error"}>Indique o nome do serviço</Alert>;
  }
  try {
    await axios
    .post(`${Url}/protocols/${protocolId}/services`,
    {
      name: nome
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    setAddService(false);
    return <Alert type={"success"}>Serviço adicionado com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await handleAddService(nome, protocolId, setAddService);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o serviço");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o serviço"}</Alert>;
    }
  };
}

async function handleEditService(id, nome, protocolId, setEditService){
  if (nome === ""){
    return <Alert type={"error"}>Indique o nome do serviço</Alert>;
  }
  try {
    await axios
    .put(`${Url}/protocols/${protocolId}/services/${id}`,
    {
      name: nome
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    setEditService(false);
    return <Alert type={"success"}>Serviço editado com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await handleEditService(id, nome, protocolId, setEditService);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o serviço");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o serviço"}</Alert>;
    }
  };
}

async function deleteService(id, protocolId){
  try {
    await axios.delete(`${Url}/protocols/${protocolId}/services/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Serviço eliminado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteService(id, protocolId);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar o serviço"}</Alert>];
    }
  };
}

async function deleteDiscount(id, serviceId, protocolId){
  try {
    await axios.delete(`${Url}/protocols/${protocolId}/services/${serviceId}/discount/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Desconto eliminado com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await deleteDiscount(id, serviceId, protocolId);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar o desconto"}</Alert>];
    }
  };
}

async function handleAddDiscount(id, discount, description, protocolId, companies, profiles, setAddDiscount){
  if (discount === "" || description === "" || companies.length === 0 || profiles.length === 0){
    return <Alert type={"error"}>Indique o valor do desconto, o seu nome, as empresas e os perfis do serviço!</Alert>;
  }
  let finalCompanies = [];
  for (const company of companies) {
    finalCompanies.push(company.id);
  }
  let finalProfiles = [];
  for (const profile of profiles) {
    finalProfiles.push(profile.id);
  }
  try {
    await axios
    .post(`${Url}/protocols/${protocolId}/services/${id}`,
    {
      discounts: [
        {
          value: discount,
          description: description,
          companies: finalCompanies,
          profiles: finalProfiles
        }
      ]
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    setAddDiscount(false);
    return <Alert type={"success"}>Desconto adicionado com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await handleAddDiscount(id, discount, description, protocolId, companies, profiles, setAddDiscount);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o desconto");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o desconto"}</Alert>;
    }
  };
}

async function handleEditDiscount(id, serviceId, discount, description, protocolId, companies, profiles, setEditDiscount){
  if (discount === "" || description === "" || companies.length === 0 || profiles.length === 0){
    return <Alert type={"error"}>Indique o valor do desconto, o seu nome, as empresas e os perfis do serviço!</Alert>;
  }
  let finalCompanies = [];
  for (const company of companies) {
    finalCompanies.push(company.id);
  }
  let finalProfiles = [];
  for (const profile of profiles) {
    finalProfiles.push(profile.id);
  }
  try {
    await axios
    .put(`${Url}/protocols/${protocolId}/services/${serviceId}/discounts/${id}`,
    {
      discount: discount,
      description: description,
      companies: finalCompanies,
      profiles: finalProfiles
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    setEditDiscount(false);
    return <Alert type={"success"}>Desconto editado com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await handleEditDiscount(id, serviceId, discount, description, protocolId, companies, profiles, setEditDiscount);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o desconto");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o desconto"}</Alert>;
    }
  };
}

async function addProtocol(nome, descricao, link, categoria, file){
  if (nome === "" || categoria === ""){
    return <Alert type={"error"}>Os campos nome e categoria são obrigatórios</Alert>;
  }
  try {
    const res = await axios
    .post(`${Url}/protocols`,
    {
      name: nome,
      description: descricao,
      link: link,
      type_id: categoria.id
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    if (file){
      const formData = new FormData();
      formData.append('file', file);
      await axios.post(`${Url}/protocols-file/${res.data.id}`,
      formData, {
        headers: {
          Authorization: "Bearer "+getUser().token,
          'Content-Type': 'multipart/form-data'
        },
      });
    }
    return [<Alert type={"success"}>Protocolo adicionado com sucesso!</Alert>, res.data.id];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await addProtocol(nome, descricao, link, categoria, file);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o protocolo");
      return [<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o protocolo"}</Alert>, ""];
    }
  };
}

async function saveProtocol(id, nome, descricao, link, categoria, file){
  if (nome === "" || categoria === ""){
    return <Alert type={"error"}>Os campos nome e categoria são obrigatórios</Alert>;
  }
  try {
    await axios
    .put(`${Url}/protocols/${id}`,
    {
        name: nome,
        description: descricao,
        link: link,
        type_id: categoria.id,
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    if (file){
      const formData = new FormData();
      formData.append('file', file);
      await axios.post(`${Url}/protocols-file/${id}`,
      formData, {
        headers: {
          Authorization: "Bearer "+getUser().token,
          'Content-Type': 'multipart/form-data'
        },
      });
    }
    return <Alert type={"success"}>Protocolo editado com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) {
        return await saveProtocol(id, nome, descricao, link, categoria, file);
      } else {
        window.location.reload();
      }
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o protocolo");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o protocolo"}</Alert>;
    }
  };
}

function EditarProtocolos({userPermissions}) {

  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const [loadingData, setLoadingData] = useState(true);
  const [alert, setAlert] = useState("");
  const navigate = useNavigate();

  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [link, setLink] = useState("");
  const [categoria, setCategoria] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [serviceName, setServiceName] = useState("");
  const [selectedEmpresas, setSelectedEmpresas] = useState([]);
  const [selectedProfiles, setSelectedProfiles] = useState([]);
  const [services, setServices] = useState([]);

  const [categorias, setCategorias] = useState([]);
  const [nextCategorias, setNextCategorias] = useState([]);
  const [firstLoadCategorias, setFirstLoadCategorias] = useState(true);

  const [addService, setAddService] = useState(false);
  const [editService, setEditService] = useState(false);
  const [addDiscount, setAddDiscount] = useState(false);
  const [editDiscount, setEditDiscount] = useState(false);
  const [deleteServiceModal, setDeleteServiceModal] = useState("");

  const [newServiceName, setNewServiceName] = useState("");
  const [newDiscountValue, setNewDiscountValue] = useState("");
  const [newDiscountDescription, setNewDiscountDescription] = useState("");
  const [selectedNewEmpresas, setSelectedNewEmpresas] = useState([]);
  const [selectedNewProfiles, setSelectedNewProfiles] = useState([]);

  const [selectedService, setSelectedService] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState("");
  const [selectedDiscountValue, setSelectedDiscountValue] = useState("");
  const [selectedDiscountDescription, setSelectedDiscountDescription] = useState("");
  const [deleteDiscountModal, setDeleteDiscountModal] = useState("");

  const [file, setFile] = useState("");
  const [fileName, setFileName] = useState("");

  async function assignData(serviceId) {
    const thisProtocolDetailsData = await getProtocolDetails(id);
    setNome(thisProtocolDetailsData?.name);
    setDescricao(thisProtocolDetailsData?.description);
    setLink(thisProtocolDetailsData?.link);
    setCategoria(thisProtocolDetailsData?.category ?? "");
    setFileName(thisProtocolDetailsData?.path ?? "");
    setServices(thisProtocolDetailsData?.services?.length > 0 ? thisProtocolDetailsData?.services : []);
    if (serviceId){
      let newService = "";
      for (const ser of thisProtocolDetailsData.services){
        if (serviceId === ser.id){
          newService = ser;
        }
      }
      setSelectedService(newService);
    }
    setLoadingData(false);
  }

  async function fetchCompaniesData() {
    const thisCompaniesData = await getCompanies();
    setEmpresas(thisCompaniesData.companies);
  }

  async function fetchProfilesData() {
    const thisProfilesData = await getProfiles();
    setProfiles(thisProfilesData);
  }

  useEffect(() => {
    fetchCompaniesData();
    fetchProfilesData();
  }, []);


  async function getAlertEdit() {
    await setAlert("");
    const res = await saveProtocol(id, nome, descricao, link, categoria, file);
    setAlert(res);
  }

  async function getAlertAdd() {
    await setAlert("");
    const res = await addProtocol(nome, descricao, link, categoria, file);
    setAlert(res[0]);
    if (res[1]) navigate(`/protocolos/${res[1]}`)
  }

  async function getAlertAddServices() {
    await setAlert("");
    const res = await handleAddService(newServiceName, id, setAddService);
    setAlert(res);
    assignData();
  }

  async function getAlertEditServices() {
    await setAlert("");
    const res = await handleEditService(selectedService.id, serviceName, id, setEditService);
    setAlert(res);
    setSelectedService("");
    assignData();
  }

  async function getAlertDeleteServices() {
    await setAlert("");
    const res = await deleteService(selectedService.id, id);
    setSelectedService("");
    setAlert(res[1]);
    assignData();
    return res;
  }

  async function getAlertAddDiscount() {
    await setAlert("");
    const res = await handleAddDiscount(selectedService.id, newDiscountValue, newDiscountDescription, id, selectedNewEmpresas, selectedNewProfiles, setAddDiscount);
    await setAlert(res);
    assignData(selectedService.id);
  }

  async function getAlertEditDiscount(discountId) {
    await setAlert("");
    const res = await handleEditDiscount(discountId, selectedService.id, selectedDiscountValue, selectedDiscountDescription, id, selectedEmpresas, selectedProfiles, setEditDiscount);
    await setAlert(res);
    assignData(selectedService.id);
  }

  async function getAlertDeleteDiscount(discountId) {
    await setAlert("");
    const res = await deleteDiscount(discountId, selectedService.id, id);
    setAlert(res[1]);
    assignData(selectedService.id);
    return res;
  }

  useEffect(() => {
    if (id) assignData();
    else setLoadingData(false);
  }, []);

  async function fetchCategoriasData(page) {
    const thisCategoriasData = await getCategories(page);
    setNextCategorias(thisCategoriasData.next_page);
    if (firstLoadCategorias){
      setCategorias(thisCategoriasData.protocols);
      setFirstLoadCategorias(false);
    }
    else {
      setCategorias(prevCategorias => [...prevCategorias, ...thisCategoriasData.protocols]);
    }
  }

  async function checkIfImageExists() {
    await setAlert("");
    try {
      const res = await axios.get(`${Url}/image/${fileName}`, {
        headers: {
          Authorization: "Bearer "+getUser().token,
        },
        responseType: "arraybuffer"
      });
      const blob = new Blob([res.data]);
      const pdfUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }
    catch (err) {
      if (err.response.data.detail.includes("is not within folder")) return;
    }
  }

  useEffect(() => {
    fetchCategoriasData();
  }, []);

  return (
    <div className="body">
      {alert}
      {deleteServiceModal}
      {deleteDiscountModal}
      <NavBar current={"protocolos"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ?
        ""
        :
        <div className={styles.content}>
          <GoBack backRoute={`/protocolos`} backState={state?.page ? {page: state.page} : {}} />
          {
            id ?
            <h1 className={styles.backgroundName}>Editar protocolo</h1>
            :
            <h1 className={styles.backgroundName}>Adicionar protocolo</h1>
          }
          <div className={styles.formBlock}>
            <div className={styles.formBlockSection}>
              <p>Nome:</p>
              <input
                defaultValue={nome}
                onChange={(e) => setNome(e.target.value)}
              />
            </div>
            <Dropdown
              label={"Categoria:"}
              placeholder={"Escolher categoria"}
              items={categorias?.length > 0 ? categorias : []}
              onUrlChange={fetchCategoriasData}
              value={categoria}
              onValueChange={setCategoria}
              nextUrl={nextCategorias}
            />
            <div className={styles.formBlockSection}>
              <p>Descrição:</p>
              <TextareaAutosize
                style={{resize: "vertical"}}
                defaultValue={descricao}
                onChange={(e) => setDescricao(e.target.value)}
              />
            </div>
            <div className={styles.formBlockSection}>
              <p>Link:</p>
              <input
                defaultValue={link}
                onChange={(e) => setLink(e.target.value)}
              />
            </div>
            <div className={styles.formBlockSection}>
              <p>Documento:</p>
              {
                fileName ? 
                <div style={{display: "flex", width: "100%", gap: "10px", justifyContent: "space-between"}}>
                  <p style={{cursor: "pointer", fontSize: "12pt", color: "var(--text)", wordBreak: "break-all"}} onClick={() => checkIfImageExists()}>{fileName}</p>
                  <button className={styles.servicesButton} style={{margin: "5px", height: "fit-content", alignSelf: "center"}} onClick={() => {setFile(""); setFileName("");}}>Alterar</button>
                </div>
                :
                <input
                  type="file"
                  onChange={(e) => {setFile(e.target.files[0]); setFileName(e.target.files[0].name)}}
                />
              }
            </div>
            {
              id ?
              <div className={styles.formBlockSection} style={{padding: "0.4rem 1rem", margin: 0, flexWrap: "wrap"}}>
                <div className={styles.actions}>
                  {
                    addService ?
                    <HiXCircle onClick={() => {setAddService(false)}} className={styles.icon} size={22}/>
                    :
                    <HiPlusCircle onClick={() => {setSelectedService(""); setAddService(true)}} className={styles.icon} size={22}/>
                  }
                </div>
                <p>Serviços:</p>
                {
                  services.length > 0 ?
                  services.map((service, index) =>
                    <button key={index} className={styles.servicesButton} onClick={() => { setAddService(false); setEditService(false); setSelectedService(service); setServiceName(service.name);}}>{service.name}</button>
                  )
                  : ""
                }
              </div>
            : ""
            }
          </div>

          {
            id ?
            <button className={styles.btn} onClick={() => getAlertEdit()}>Guardar alterações</button>
            :
            <button className={styles.btn} onClick={() => getAlertAdd()}>Adicionar protocolo</button>
          }

          {
            addService ?
            <div className={styles.serviceTitle}>
              <input
                className={styles.input}
                placeholder="Nome do serviço"
                value={newServiceName}
                onChange={(e) => setNewServiceName(e.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") getAlertAddServices();
                }}
              />
              <div className={styles.actions}>
                <HiCheck onClick={() => getAlertAddServices()} className={styles.icon} size={22}/>
              </div>
            </div>
            :""
          }

          {
            selectedService ?
            <div>
              <div className={styles.serviceTitle}>
              {
                editService ?
                <input className={styles.input} placeholder="Nome do serviço" value={serviceName} onChange={(e) => setServiceName(e.target.value)}/>
                :
                <h3>{serviceName}</h3>
              }
              {
                editService ?
                  <div className={styles.actions}>
                    <HiCheck onClick={() => {getAlertEditServices()}} className={styles.icon} size={22}/>
                  </div>
                  :
                  <div className={styles.actions}>
                    <HiPencil onClick={() => {setEditService(true)}} className={styles.icon} size={22}/>
                    <HiTrash className={styles.icon} onClick={() => setDeleteServiceModal(<DeleteModal close={setDeleteServiceModal} objectId={selectedService.id} objectName={`o serviço ${selectedService.name}`} deleteFunction={getAlertDeleteServices}/>)} size={22}/>
                  </div>
              }
              </div>
              <div>
                <div className={styles.tableValues}>
                  <div className={styles.tableValuesHeader}>
                    <p title="Valor">Valor</p>
                    <p title="Desconto">Desconto</p>
                    <p title="Empresas">Empresas</p>
                    <p title="Perfis" style={{display: "flex", alignItems: "center", justifyContent: "center", gap: "5px"}}>Perfis<HiInformationCircle size={18} title={`Nível 1 - Administradores/Assessores da Savoy Signature\nNível 2 - Diretores SAVOY + Administradores AFAVIAS/CTM/INERTES\nNível 3 - Colaboradores das empresas detidas pelo Grupo AFA + Administração e Direções das empresas participadas\nNível 4 - Colaboradores das empresas participadas`} style={{cursor: "help"}} /></p>
                    <div className={styles.actions}>
                      {
                        addDiscount ?
                        <HiXCircle onClick={() => {setAddDiscount(false)}} className={styles.icon} size={22}/>
                        :
                        <HiPlusCircle onClick={() => {setEditDiscount(false); setAddDiscount(true)}} className={styles.icon} size={22}/>
                      }
                    </div>
                  </div>
                  {
                    addDiscount ?
                    <div className={styles.tableValuesBody}>
                      <input
                        className={styles.input}
                        placeholder="Valor"
                        value={newDiscountValue}
                        onChange={(e) => setNewDiscountValue(e.target.value)}
                      />
                      <TextareaAutosize
                        style={{resize: "none"}}
                        className={styles.input}
                        placeholder="Produto alvo do desconto"
                        value={newDiscountDescription}
                        onChange={(e) => setNewDiscountDescription(e.target.value)}
                      />
                      <div style={{marginBottom: "1rem"}}>
                        <MultiSelect
                          label={false}
                          items={empresas}
                          placeholder={"Escolher empresas"}
                          value={selectedNewEmpresas}
                          onValueChange={setSelectedNewEmpresas}
                        />
                      </div>
                      <div style={{marginBottom: "1rem"}}>
                        <MultiSelect
                          label={false}
                          items={profiles}
                          placeholder={"Escolher perfis"}
                          value={selectedNewProfiles}
                          onValueChange={setSelectedNewProfiles}
                        />
                      </div>
                      <div className={styles.actions}>
                        <HiCheck onClick={() => {getAlertAddDiscount()}} className={styles.icon} size={22}/>
                      </div>
                    </div>
                    : ""
                  }
                  {
                    selectedService.discounts.length > 0 ?
                      selectedService.discounts.map((discount, indexDiscount) =>
                        selectedDiscount === indexDiscount && editDiscount ?
                          <div key={indexDiscount} className={styles.tableValuesBody}>
                            <input
                              className={styles.input}
                              placeholder="Valor"
                              value={selectedDiscountValue}
                              onChange={(e) => setSelectedDiscountValue(e.target.value)}
                            />
                            <TextareaAutosize
                              style={{resize: "none"}}
                              className={styles.input}
                              placeholder="Produto alvo do desconto"
                              value={selectedDiscountDescription}
                              onChange={(e) => setSelectedDiscountDescription(e.target.value)}
                            />
                            <div style={{marginBottom: "1rem"}}>
                              <MultiSelect
                                label={false}
                                items={empresas}
                                placeholder={"Escolher empresas"}
                                value={selectedEmpresas}
                                onValueChange={setSelectedEmpresas}
                              />
                            </div>
                            <div style={{marginBottom: "1rem"}}>
                              <MultiSelect
                                label={false}
                                items={profiles}
                                placeholder={"Escolher perfis"}
                                value={selectedProfiles}
                                onValueChange={setSelectedProfiles}
                              />
                            </div>
                            
                            <div className={styles.actions}>
                                <HiCheck onClick={() => {getAlertEditDiscount(discount.id)}} className={styles.icon} size={22}/>
                            </div>
                          </div>
                        :
                          <div key={indexDiscount} className={styles.tableValuesBody}>
                            <p title={discount.value}>{discount.value}</p>
                            <p title={discount.description}>{discount.description}</p>
                            <p title={discount.companies.map((empresa) =>` ${empresa.name}`)}>
                              {
                                discount.companies.map((empresa, index) =>
                                  `${index !== discount.companies.length - 1 ? `${empresa.name}, ` : empresa.name}`
                                )
                              }
                            </p>
                            <p title={discount.profiles.map((profile) =>` ${profile.name}`)}>
                              {
                                discount.profiles.map((profile, index) =>
                                  `${index !== discount.profiles.length - 1 ? `${profile.name}, ` : profile.name}`
                                )
                              }
                            </p>
                            <div className={styles.actions}>
                              <HiPencil onClick={() => {setSelectedDiscount(indexDiscount); setSelectedDiscountValue(discount.value); setSelectedDiscountDescription(discount.description); setSelectedEmpresas(discount.companies); setSelectedProfiles(discount.profiles); setAddDiscount(false); setEditDiscount(true)}} className={styles.icon} size={22}/>
                              <HiTrash className={styles.icon} onClick={() => setDeleteDiscountModal(<DeleteModal close={setDeleteDiscountModal} objectId={discount.id} objectName={`o desconto ${discount.description}`} deleteFunction={getAlertDeleteDiscount}/>)} size={22}/>
                            </div>
                          </div>
                      )
                    :""
                  }
                </div>
              </div>
            </div>
            :""
          }
        </div>
        }
    </div>
  );
}

export default EditarProtocolos;